import React from "react";

const Icon = ({ src, alt, className = "", iconClassName = "" }) => {
  return (
    <div
      className={`lg:w-[50px] lg:h-[50px] w-[44px] h-[44px] border-2 border-black hover:shadow-[0_0_0_1px_black] rounded-full bg-[#FEFBF6] flex items-center justify-center cursor-pointer ${className}`}
    >
      <img src={src} alt={alt} className={iconClassName} />
    </div>
  );
};

export default Icon;
